import { render, staticRenderFns } from "./AcademyNoticeList.vue?vue&type=template&id=7f639da4&scoped=true&lang=pug&"
import script from "./AcademyNoticeList.vue?vue&type=script&lang=ts&"
export * from "./AcademyNoticeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f639da4",
  null
  
)

export default component.exports